<template>
  <div>
    <div class="i_fcst_tem">
      <div class="t_line"></div>
      <!--<div class="t_hov">800hpa</br>2000m 6400ft</div>-->
      <div class="t_drag" style="top: -15px">
        <p>100hpa</p>
        <p>15900米</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    $(".i_fcst_tem").hide();
  },
};
</script>

<style lang="less" scoped>
.i_fcst_tem {
  display: none;
  position: absolute;
  bottom: 100px;
  left: 38px;
  z-index: 1002;
  width: 140px;
  height: 270px;
  .t_line {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 270px;
    width: 8px;
    border-radius: 5px;
    background: #000000;
    cursor: pointer;
    opacity: 0.5;
  }

  .t_drag {
    font-size: 12px;
    line-height: 25px;
    max-width: 100px;
    position: absolute;
    top: 250px;
    left: 18px;
    background: #1f2f65;
    padding: 0px 10px;
    text-align: center;
    border-radius: 8px;
    cursor: pointer;
    color: #fff;
    opacity: 0.8;
    z-index: 4;
  }
}
</style> 